import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/pozorovani/$dochazkaId")({
  beforeLoad: requirePermissionGuard("hca.pozorovani.write"),
});
